import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EmpruntProfileLayout from './EmpruntProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import EleveService from '../../services/EleveService';
import EmpruntService from '../../services/EmpruntService';
import LivreService from '../../services/LivreService';

const ViewEmprunt = ({ onClick }) => {
	const { id } = useParams();
	const [emprunt, setEmprunt] = useState(null); // Changed this from "eleve" to "Emprunt"
	const [eleveOptions, setEleveOptions] = useState([]);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [selectedLivre, setSelectedLivre] = useState('');
	const [selectedEleve, setSelectedEleve] = useState('');
	const [LivreOptions, setLivreOptions] = useState([]);

	useEffect(() => {
		Promise.all([EmpruntService.getEmprunt(id)]).then(([empruntData]) => {
			// Added "eleveData" to unpack second promise result
			setEmprunt(empruntData.data);

			if (empruntData && empruntData.data) {
				const empruntEleve = empruntData.data.eleve;
				setSelectedEleve(empruntEleve);

				const empruntLivre = empruntData.data.livre;
				setSelectedLivre(empruntLivre);
			}
		});
	}, [id]);
	useEffect(() => {
		const fetchEleveOptions = async () => {
			try {
				const eleves = await EleveService.getEleveOptions();
				setEleveOptions(eleves);
			} catch (error) {
				console.error('Error fetching students options', error);
			}
		};

		fetchEleveOptions();
	}, []);

	const ELEVE_CHOICES = eleveOptions;

	useEffect(() => {
		const fetchLivreOptions = async () => {
			try {
				const Livres = await LivreService.getLivreOptions();
				setLivreOptions(Livres);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchLivreOptions();
	}, []);

	const LIVRE_CHOICES = LivreOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const empruntData = new FormData();

				// Add all your form data to the FormData
				empruntData.append(
					'date_retour_effective',
					form.date_retour_effective.value
				);
				empruntData.append('date_retour_prevue', form.date_retour_prevue.value);
				empruntData.append('date_emprunt', form.date_emprunt.value);
				empruntData.append('eleve', form.eleve.value);
				empruntData.append('livre', form.livre.value);

				// Call the EleveService to create the eleve
				const response = await EmpruntService.updateEmprunt(id, empruntData);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					"Erreur lors de la mise à jour des informations sur l'emprunt",
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<EmpruntProfileLayout>
			{emprunt && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}

								<Row>
									{/* date_retour_prevue */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="date_retour_prevue">
												Date de retour prevue{' '}
												<span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="date_retour_prevue"
												type="date"
												placeholder="Saisir la Date de retour prevue"
												id="date_retour_prevue"
												isInvalid={!!feedbackMessages['date_retour_prevue']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														type: e.target.value ? '' : ''
													}));
												}}
												defaultValue={emprunt.date_retour_prevue}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['date_retour_prevue']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* categorie et date_retour_effective  */}
										<Form.Group>
											<Row>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="date_retour_effective">
														Date de retour effective{' '}
														<span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="date_retour_effective"
														type="date"
														placeholder="Saisir la Date de retour effective"
														id="date_retour_effective"
														required
														isInvalid={
															!!feedbackMessages['date_retour_effective']
														}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																date_retour_effective: e.target.value
																	? ''
																	: 'Date de retour effective est requis.'
															}));
														}}
														defaultValue={emprunt.date_retour_effective}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['date_retour_effective']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* livre */}
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="livre">
												Livre <span className="text-danger">*</span>
											</Form.Label>
											<Form.Select
												name="livre"
												required
												value={selectedLivre}
												isInvalid={!!feedbackMessages['livre']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedLivre(value);
													// Reset feedback messages for points fields when livre changes
													setFeedbackMessages({});
												}}
											>
												<option value="">Sélectionner le nom du livre</option>
												{LIVRE_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback livre="invalid">
												{feedbackMessages['eleve']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* Quantite et eleve  */}
										<Form.Group>
											<Row>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="date_emprunt">
														Date d'emprunt{' '}
														<span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="date_emprunt"
														type="date"
														placeholder="Saisir la date d'emprunt "
														id="date_emprunt"
														required
														isInvalid={!!feedbackMessages['date_emprunt']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																date_emprunt: e.target.value
																	? ''
																	: "La Date d'emprunt est requis."
															}));
														}}
														defaultValue={emprunt.date_emprunt}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['date_emprunt']}
													</Form.Control.Feedback>
												</Col>
												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="eleve">
														Eleve <span className="text-danger">*</span>
													</Form.Label>
													<Form.Select
														name="eleve"
														required
														value={selectedEleve}
														isInvalid={!!feedbackMessages['eleve']}
														onChange={(e) => {
															const value = e.target.value;
															setSelectedEleve(value);
															// Reset feedback messages for points fields when eleve changes
															setFeedbackMessages({});
														}}
													>
														<option value="">
															Sélectionner le nom de l'élève
														</option>
														{ELEVE_CHOICES.map((choice, index) => (
															<option key={index} value={choice.value}>
																{choice.label}
															</option>
														))}
													</Form.Select>
													<Form.Control.Feedback eleve="invalid">
														{feedbackMessages['eleve']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Mettre à jour
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</EmpruntProfileLayout>
	);
};

export default ViewEmprunt;
